import React from 'react';
import { footerLinks } from '../data/content';
export function Footer() {
  return <footer className="w-full border-t border-stone-200 bg-white px-5 py-12" data-id="element-91" data-mp="3geze367ujv27">
      <div className="mx-auto max-w-5xl text-center" data-id="element-92" data-mp="3gh3s4gzgmag7">
        <p className="text-xl font-bold uppercase tracking-tight text-stone-900" data-id="element-93" data-mp="32p5naics70pu">
          Math Ready
        </p>
        <nav aria-label="Footer" data-id="element-94" data-mp="36pz8v52r43fk">
          <ul className="mt-5 flex flex-wrap items-center justify-center gap-x-6 gap-y-3 text-xs font-medium text-stone-600" data-id="element-95" data-mp="3uf0opddwyguv">
            {footerLinks.map(link => <li key={link} data-id="element-96" data-mp="37xwcimca4j2">
                <a href="#offer" className="transition-colors hover:text-orange-600" data-id="element-97" data-mp="3lec9ifcsaage">
                  {link}
                </a>
              </li>)}
          </ul>
        </nav>
        <p className="mx-auto mt-7 max-w-2xl text-[11px] leading-relaxed text-stone-400" data-id="element-98" data-mp="29ydvdx2r0y8b">
          © 2026 Math Ready. All rights reserved.
        </p>
      </div>
    </footer>;
}